import {
  Container as RBcontainer,
  Row as RBrow,
  Col as RBcol,
  Modal as RBmodal,
  Card as RBcard,
  CardDeck as RBCardDeck,
  CardColumns as RBCardColumns,
  Button as RBbutton,
  ButtonGroup as RBbuttonGroup,
  Dropdown as RBdropDown,
  DropdownButton as RBdropdownButton,
  ProgressBar as RBprogressBar,
  Tooltip as RBtooltip,
  Form as RBform,
  OverlayTrigger as RBoverlayTrigger
} from "react-bootstrap";
import RBImage from "react-bootstrap/Image";
import RBtab from "react-bootstrap/Tab";
import RBnav from "react-bootstrap/Nav";
import RBaccordion from "react-bootstrap/Accordion";
import { useAccordionToggle as RBuseAccordionToggle } from "react-bootstrap/AccordionToggle";
import RBspinner from "react-bootstrap/Spinner";
import RBreadcrumb from "react-bootstrap/Breadcrumb";
import ROwlCarousel from "react-owl-carousel2";
import EXTextTruncate from 'react-text-truncate';
import RCountdown from "react-countdown";
import { sha256 as hash256} from "js-sha256";

import styled from "styled-components";
//Next Dependencies
import NxtHead from "next/head";
import NxtRouter, {
  useRouter as UseRouter,
  withRouter as WithRouter
} from "next/router";
import NxtLink from "next/link";

import JsCookie from "js-cookie";

//Redux Dependencies
import {
  connect as ReduxConnect,
  useDispatch as ReduxUseDispatch
} from "react-redux";

//ReactPannellum Dependencies
import ReactPannellum, {
  getConfig as GetConfig,
  setYaw as SetYaw
} from "../../library/react-pannellum";

// React Bootstrap dependencies
export const Container = RBcontainer;
export const Row = RBrow;
export const Col = RBcol;
export const Modal = RBmodal;
export const Image = RBImage;
export const Card = RBcard;
export const CardDeck = RBCardDeck;
export const CardColumns = RBCardColumns;
export const Button = RBbutton;
export const ButtonGroup = RBbuttonGroup;
export const Dropdown = RBdropDown;
export const DropdownButton = RBdropdownButton;
export const Tab = RBtab;
export const Nav = RBnav;
export const Accordion = RBaccordion;
export const useAccordionToggle = RBuseAccordionToggle;
export const Spinner = RBspinner;
export const Breadcrumb = RBreadcrumb;
export const OwlCarousel = ROwlCarousel;
export const Countdown = RCountdown;
export const ProgressBar = RBprogressBar;
export const Tooltip = RBtooltip;
export const Form = RBform;
export const OverlayTrigger = RBoverlayTrigger;
export const TextTruncate = EXTextTruncate;

//Next Dependencies
export const Head = NxtHead;
export const Router = NxtRouter;
export const Link = NxtLink;
export const useRouter = UseRouter;
export const withRouter = WithRouter;

//Div Container
export const CustomContainer = styled.div``;
export const FooterContainer = styled.footer``;
export const Text = styled.label``;
export const Progress = styled.progress``;

//Redux Connect
export const connect = ReduxConnect;
export const useDispatch = ReduxUseDispatch;

//ReactPannellum Dependencies
export const Pannellum = ReactPannellum;
export const PannellumGetConfig = GetConfig;
export const PannellumSetYaw = SetYaw;

//JS-Cookie
export const Cookie = JsCookie;

export const sha256 = hash256;